export default __webpack_public_path__ + "static/media/4.555b2ca4.jpg";